import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './Photography.css';

const Photography = () => {
  return (
    <div className="photography-page">
      <PageBanner
        title="Photography"
        image={productionRouteBanners.photography}
        imageAlt={productionRouteBannerAlts.photography}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Photography Services</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Capturing your special moments with professional photography services
            </p>
          </div>
          
          <div className="about-content">
            <p>
              Our professional photographers capture every precious moment of your event with 
              creativity and expertise. From candid shots to posed portraits, we ensure you have 
              beautiful memories to cherish forever.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Photography;
